"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submittedStageThree = void 0;
var joi_1 = __importDefault(require("joi"));
exports.submittedStageThree = joi_1.default.object({
    combinationFlag: joi_1.default.boolean()
        .optional()
        .allow(''),
    toolDetail: joi_1.default.array().items(joi_1.default.object({
        amount: joi_1.default.number()
            .min(0)
            .max(9999999999999.99)
            .precision(2)
            .options({ convert: false })
            .when('....combinationFlag', {
            is: true,
            then: joi_1.default.number().required(),
            otherwise: joi_1.default.number()
                .strip()
                .optional()
                .allow(''),
        }),
        tool: joi_1.default.string()
            .min(0)
            .max(500)
            .when('....combinationFlag', {
            is: true,
            then: joi_1.default.string().required(),
            otherwise: joi_1.default.string()
                .strip()
                .optional()
                .allow(''),
        }),
    })),
});
exports.default = { submittedStageThree: exports.submittedStageThree };
